// Versão do app - gerado automaticamente
export const APP_VERSION = '5.47'
export const BUILD_DATE = '18/07/2026, 05:07'
